import { DealStatus, ProgrammaticAndDirectSalesBookingStatus } from 'components/common/types/Deal.types';
import { STATUS_SETTINGS } from 'components/pages/Planner/PlannerLineActions/DirectSalesPlannerLineActions/Status/StatusPanel/StatusPanel.types';
import { Color } from 'lib/Chip/Chip.types';

export type StatusSettingsProgrammatic = Record<
  ProgrammaticAndDirectSalesBookingStatus,
  { text: string; style: Color }
>;

export type StatusSettingsProgrammaticItem = StatusSettingsProgrammatic[keyof StatusSettingsProgrammatic];

export const bookingStatusStyles: StatusSettingsProgrammatic = {
  [DealStatus.PENDING_APPROVAL]: {
    text: 'Pending',
    style: Color.YELLOW,
  },
  [DealStatus.APPROVED]: {
    text: 'Approved',
    style: Color.PRIMARY,
  },
  [DealStatus.REJECTED]: {
    text: 'Rejected',
    style: Color.RED,
  },
  [DealStatus.TERMINATED]: {
    text: 'Terminated',
    style: Color.RED,
  },
  [DealStatus.FAILED]: {
    text: 'Failed',
    style: Color.RED,
  },
  [DealStatus.PENDING_RESERVATION]: {
    text: 'Pending reservation',
    style: Color.GREY,
  },
  [DealStatus.RESERVED]: {
    text: 'Reserved',
    style: Color.GREY,
  },
  ...STATUS_SETTINGS,
};

export const defaultBookingStatusStyle = { text: 'New', style: Color.GREY };

export const defaultDirectSalesBookingStatusStyle = { text: '', style: undefined };
